import { render, staticRenderFns } from "./StockAudioBox.vue?vue&type=template&id=fc490612&scoped=true"
import script from "./StockAudioBox.vue?vue&type=script&lang=js"
export * from "./StockAudioBox.vue?vue&type=script&lang=js"
import style0 from "./StockAudioBox.vue?vue&type=style&index=0&id=fc490612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc490612",
  null
  
)

export default component.exports